import api from './api'
import Cookies from 'js-cookie';

export async function getFoods() {
    const res = await api.get('/api/foods', {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
    // console.log(res.data);
    return res.data
}

export async function getTable() {
    const res = await api.get('/api/foods/table', {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })

    // console.log(res.data);
    // console.log(api.defaults.baseURL);
    return res.data
}

export async function getCategory() {
    const res = await api.get('/api/foods/category', {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
    // console.log(res.data);
    return res.data
}

export async function createFood(food) {
    await api.post('/api/foods', food, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
}

export async function createCat(cat) {
    const token = Cookies.get('token')
    // console.log('Token being sent:', token) // kiểm tra giá trị token
    const url = '/api/foods/category/add'
    // console.log(url)
    await api.post(
        url,
        cat,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    )
}

export async function updateFood(food) {
    await api.put('/api/foods', food, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
}

// New: create a table (bổ sung tạo bàn)
export async function createTable(table) {
    const token = Cookies.get('token')
    const url = '/api/orders/create-table'
    // console.log('Creating table:', table, '->', url)
    const res = await api.post(url, table, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    })
    return res.data
}
